import { ChangeEvent, useRef } from 'react';

import { MagnifyingGlassIcon, CrossIcon } from '@grupoboticario/flora-react-icons';
import { SEARCH_INPUT_CONST } from 'ui/components';
import { Search } from 'ui/components/compounds/SearchInput/SearchInput.styles';
import { Input, InputProps } from 'ui/components/primitives';

type HeaderSearchInputProps = Omit<InputProps, 'onChange'> & {
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onSearchClick: (event: React.FormEvent<HTMLFormElement>) => void;
  searchValue: string;
  handleClear: () => void;
  focus?: boolean;
};

const HeaderSearchInput = ({
  autoFocus,
  ghost,
  handleChange,
  searchValue,
  handleClear,
  onSearchClick,
  ...props
}: HeaderSearchInputProps) => {
  const ref = useRef(null);
  return (
    <Search.Form onSubmit={onSearchClick}>
      <Search.FocusTarget disabled={!autoFocus}>
        <Input
          autoFocus={autoFocus}
          ghost={ghost}
          data-testid={SEARCH_INPUT_CONST.TEST_ID}
          name="q"
          onChange={handleChange}
          renderPrefix={
            <Search.ButtonSearch aria-label="pesquisar" size="small">
              <MagnifyingGlassIcon size={24} />
            </Search.ButtonSearch>
          }
          renderSuffix={
            searchValue && (
              <Search.ButtonClear
                aria-label="limpar pesquisa"
                data-testid="clear-button"
                onClick={handleClear}
                size="small"
              >
                <CrossIcon size={24} />
              </Search.ButtonClear>
            )
          }
          type={'text'}
          value={searchValue}
          ref={ref}
          {...props}
        />
      </Search.FocusTarget>
    </Search.Form>
  );
};

export default HeaderSearchInput;
